import React, { useState, useEffect } from 'react';
import { LoadingOverlay, Stack, Title } from '@mantine/core';
import { useApp } from '../context/AppContext';
import BusinessInfoForm from './forms/BusinessInfoForm';
import { useSalon } from '../context/SalonContext';
import { useNavigate } from 'react-router-dom';
function BusinessInfoPage() {
  const navigate = useNavigate();
  const { businessInfo, setBusinessInfo } = useSalon();
  const { getSalons, createSalon, updateSalon } = useApp();
  const [currentData, setCurrentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!businessInfo) {
      const fetchSalons = async () => {
        try {
          const salons = await getSalons();
          setCurrentData(salons[0]);
        } catch (error) {
          if (error.status === "404") {
            setCurrentData({});
          }
        } finally {
          setIsLoading(false);
        }
      };

      fetchSalons();
    } else {
      setCurrentData(businessInfo);
      setIsLoading(false);
    }
  }, [businessInfo]);

  const handleSubmit = async (businessData) => {
    setIsLoading(true);
    try {
      if (!businessData) {
        navigate('/business-hours');
      } else {

        const response = businessInfo ? 
          await updateSalon(businessData) : 
          await createSalon(businessData);      

        if (response) {
          setBusinessInfo(response);
          navigate('/business-hours');
        }
      }
    } catch (error) {
      const createOrUpdate = businessInfo ? 'update' : 'create';
      console.error(`Error with ${createOrUpdate} salon:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack>
      <LoadingOverlay visible={isLoading} overlayBlur={2} />
      <Stack p={{base: "0", sm: "md", md: "xl"}} w="90%" maw="60rem" mx="auto" align="center">
        <Title order={2} c="gray.8">Confirm your business information</Title>
        <BusinessInfoForm
          initialData={currentData}
          onSubmit={handleSubmit}
          isEditing={!!businessInfo}
        />
      </Stack>
    </Stack>
  );
}

export default BusinessInfoPage; 